var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysMyWallet = function SvgSysMyWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 19 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.223 4C1.548 4 1 4.548 1 5.223v6.554C1 12.452 1.548 13 2.223 13h14.554c.675 0 1.223-.548 1.223-1.223V5.223C18 4.548 17.452 4 16.777 4H2.223ZM0 5.223C0 3.995.995 3 2.223 3h14.554C18.005 3 19 3.995 19 5.223v6.554A2.223 2.223 0 0 1 16.777 14H2.223A2.223 2.223 0 0 1 0 11.777V5.223Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.223 1C1.548 1 1 1.548 1 2.223v9.554C1 12.452 1.548 13 2.223 13h14.554c.675 0 1.223-.548 1.223-1.223V2.223C18 1.548 17.452 1 16.777 1H2.223ZM0 2.223C0 .995.995 0 2.223 0h14.554C18.005 0 19 .995 19 2.223v9.554A2.223 2.223 0 0 1 16.777 14H2.223A2.223 2.223 0 0 1 0 11.777V2.223Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.101 4.006A1.223 1.223 0 0 0 1 5.223v6.554A1.223 1.223 0 0 0 2.223 13h14.554A1.223 1.223 0 0 0 18 11.777V5.921c-.439.343-1.03.875-1.67 1.454l-.1.092a52.068 52.068 0 0 1-1.841 1.618 9.094 9.094 0 0 1-.824.614 2.739 2.739 0 0 1-.367.2c-.111.05-.26.101-.421.101h-.132L2.1 4.006ZM18.476 5.6c.017-.004.018-.007 0 0ZM.65 3.651A2.223 2.223 0 0 1 2.223 3h.132l10.488 5.962c.049-.024.11-.06.184-.106.197-.126.444-.312.729-.545.542-.444 1.18-1.022 1.81-1.592l.093-.085c.651-.589 1.294-1.169 1.775-1.54.23-.177.47-.345.676-.426a.709.709 0 0 1 .52-.018c.314.124.37.423.37.573v6.554A2.223 2.223 0 0 1 16.777 14H2.223A2.223 2.223 0 0 1 0 11.777V5.223c0-.59.234-1.155.651-1.572Z",
    clipRule: "evenodd"
  })));
};
export default SvgSysMyWallet;